import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import * as fromComponents from './components';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        ...fromComponents.components,
    ],
    exports: [
        ReactiveFormsModule,
        RouterModule,
        ...fromComponents.components
    ],
})
export class ComponentsModule {
}
